import { createContext } from "react";

export const emptyTicket = {
  customerId: "",
  assetId: "",
  customerTicketNo: "",
  activityType: "",
  category: "",
  subCategory: "",
  vaultAccessRequired: "No",
  assignmentGroup: "",
  assigneeId: "",
  secondaryAssigneeId: "",
  creationChannel: "Web",
  reportedBy: "",
  auditedBy: "",
  isChargeable: "Yes",
  isCustomerComplaint: "No",
  billingCharges: "Yes",
  correlationId: "",
  priority: "Normal",
  remarks: "",
  locationName: "",
  region: "",
};

export const SERVICE_TYPES = {};
export const CREATION_CHANNELS = [
  { id: "Customer Portal", text: "Customer Portal" },
  { id: "Web", text: "Web" },
  { id: "Auto Email", text: "Auto Email" },
];
export const TOGGLE = [
  { id: "Yes", text: "Yes" },
  { id: "No", text: "No" },
];
export const PRIORITIES_LIST = [
  { id: "Critical", text: "1-Critical", value: 1 },
  { id: "High", text: "2-High", value: 2 },
  { id: "Normal", text: "3-Normal", value: 3 },
  { id: "Low", text: "4-Low", value: 4 },
];

export const StatusContext = createContext({
  status: "open",
  setStatus: () => {},
});
